import { useMutation, useQuery } from '@apollo/client'
import {
  GET_ASSIGNMENTS,
  GET_ASSIGNMENTS_AS_DELEGATE,
  GET_ASSIGNMENTS_BY_PROJECTS,
  CREATE_ASSIGNMENT,
  UPDATE_ASSIGNMENT,
  DELETE_ASSIGNMENT,
  ADJUST_ASSIGNMENT,
} from '../../entities/assignment/service/query'

export const useAssignments = ({ startISO, endISO, selectedDelegateId, skip = false }) => {
  const query = selectedDelegateId ? GET_ASSIGNMENTS_AS_DELEGATE : GET_ASSIGNMENTS
  const variables = {
    startISO,
    endISO,
    ...(selectedDelegateId && { delegateId: selectedDelegateId }),
  }

  const { data, loading, error, refetch } = useQuery(query, {
    variables,
    skip,
  })

  const assignments = selectedDelegateId ? data?.getAssignments_asDelegate : data?.getAssignments

  return { assignments, loading, error, refetch }
}

export const useAssignmentsByProjects = ({ projectIds, startISO, endISO, skip = false }) => {
  const { data, loading, error, refetch } = useQuery(GET_ASSIGNMENTS_BY_PROJECTS, {
    variables: { projectIds, startISO, endISO },
    skip,
  })

  return {
    assignments: data?.getAssignmentsByProjects,
    loading,
    error,
    refetch,
  }
}

export const useCreateAssignment = () => {
  const [createAssignment, { data, loading, error }] = useMutation(CREATE_ASSIGNMENT)

  const handleCreateAssignment = assignment => {
    return createAssignment({
      variables: {
        personId: assignment.personId,
        projectId: assignment.projectId,
        startDate: assignment.startDate,
        endDate: assignment.endDate,
        percent: assignment.percent,
        investment: assignment.investment,
      },
    })
  }

  return {
    createAssignment: handleCreateAssignment,
    data: data?.createAssignment,
    loading,
    error,
  }
}

export const useUpdateAssignment = () => {
  const [updateAssignment, { data, loading, error }] = useMutation(UPDATE_ASSIGNMENT)

  const handleUpdateAssignment = (assignmentId, assignment) => {
    return updateAssignment({
      variables: {
        _id: assignmentId,
        personId: assignment.personId,
        projectId: assignment.projectId,
        startDate: assignment.startDate,
        endDate: assignment.endDate,
        percent: assignment.percent,
        investment: assignment.investment,
      },
    })
  }

  return {
    updateAssignment: handleUpdateAssignment,
    data: data?.updateAssignment,
    loading,
    error,
  }
}

export const useDeleteAssignment = () => {
  const [deleteAssignment, { data, loading, error }] = useMutation(DELETE_ASSIGNMENT)

  const handleDeleteAssignment = assignmentId => {
    return deleteAssignment({
      variables: { _id: assignmentId },
    })
  }

  return {
    deleteAssignment: handleDeleteAssignment,
    data: data?.deleteAssignment,
    loading,
    error,
  }
}

export const useAdjustAssignment = () => {
  const [adjustAssignment, { data, loading, error }] = useMutation(ADJUST_ASSIGNMENT)

  const handleAdjustAssignment = ({
    assignmentId,
    status,
    comment,
    requester,
    percent,
    startDate,
    endDate,
    leadId,
  }) => {
    return adjustAssignment({
      variables: {
        assignmentId,
        status,
        comment,
        requester,
        percent,
        startDate,
        endDate,
        leadId,
      },
    })
  }

  return {
    adjustAssignment: handleAdjustAssignment,
    data: data?.adjustAssignment,
    loading,
    error,
  }
}
